import axios, { AxiosError } from 'axios';

export const apiClient = axios.create({
	baseURL: '/api',
	withCredentials: true,
	timeout: 30000
});

export function extractErrorMessage(error: unknown): string {
	if (error instanceof AxiosError) {
		const data = error.response?.data;
		if (data && typeof data === 'object') {
			const maybeMessage = (data as { message?: unknown }).message;
			if (typeof maybeMessage === 'string') return maybeMessage;
			if (Array.isArray(maybeMessage) && maybeMessage.length > 0) return String(maybeMessage[0]);
		}
		return error.message;
	}
	return error instanceof Error ? error.message : String(error);
}
